// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import styled from "styled-components";

const Heading = styled.h3`
  width: 100%;
  margin: 15px 0;
  padding: 5px 10px;
  color: #828282;
  background: #f2f2f2;
`;

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'title' implicitly has an 'any' type.
function PreferenceHeading({ title }) {
  return <Heading>{title}</Heading>;
}

export { PreferenceHeading };
